<template>
  <div class="email-verification-wrap" :class="[variant, { 'show-hint': showHint }]">
    <div v-if="!currentUser.profile.active_email" class="email-verification-hint email-verification-hint--invalid">
      <font-awesome-icon icon="fa fa-triangle-exclamation" />
      <div>
        <span v-if="showEmail" v-html="$gettextInterpolate(emailNotValidated, { useremail: currentUser.email })" />
        <span v-else>
          {{
            $gettext(
              'Your email has not yet been validated. You can only send emails via Gekko with a validated email.'
            )
          }}
        </span>
        <span v-if="verificationEmailSent">
          {{ verificationEmailSentTxt }}
        </span>
        <a v-else-if="showLink" @click="sendVerificationEmail" class="text-blue cursor-pointer">{{
          $gettext('Send email for verification')
        }}</a>
      </div>
    </div>
    <div v-else-if="showValid" class="email-verification-hint email-verification-hint--valid">
      <font-awesome-icon icon="fa-regular fa-circle-check" />
      <span v-if="showEmail" v-html="$gettextInterpolate(emailValidated, { useremail: currentUser.email })" />
      <span v-else>{{ $gettext('Verified email') }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProfileService from '@/store/services/profile.service.js'
export default {
  name: 'EmailValidityHint',
  components: {},
  props: {
    showLink: {
      type: Boolean,
      default: false,
    },
    showValid: {
      type: Boolean,
      default: false,
    },
    showEmail: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      verificationEmailSent: false,
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'main/getCurrentUser',
    }),
    verificationEmailSentTxt() {
      return this.$gettext('A verification email has been sent, check your email address to verify your email.')
    },
    emailValidated() {
      return this.$gettext("Your email <span class='text-brand'>%{ useremail }</span> has been validated.")
    },
    emailNotValidated() {
      return this.$gettext(
        "Your email <span class='text-brand'>%{ useremail }</span> has not yet been validated. Please click the link in the validation email we sent you."
      )
    },
    showHint() {
      return this.showValid || !this.currentUser.profile.active_email
    },
  },
  created() {},
  mounted() {},
  methods: {
    sendVerificationEmail() {
      ProfileService.sendVerificationEmail()
        .then(() => {
          this.verificationEmailSent = true
          this.$store.commit('setAlert', {
            title: this.$gettext('Email sent'),
            text: this.verificationEmailSentTxt,
            variant: 'success',
            duration: 4,
          })
        })
        .catch(() => {
          this.$store.commit('setAlert', {
            title: this.$gettext('Failed to send email'),
            text: this.$gettext('We failed to send you an email, please try again later.'),
            variant: 'danger',
            duration: 4,
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.email-verification-wrap {
  display: flex;
  .email-verification-hint {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0;
    font-size: 14px;
    .svg-inline--fa {
      font-size: 20px;
      opacity: 0.7;
    }
    &--valid {
      .svg-inline--fa {
        color: $colorBrand;
      }
    }
    &--invalid {
      .svg-inline--fa {
        color: $colorWarning;
      }
    }
  }
  &.boxy {
    &.show-hint {
      padding: 1rem 0;
    }
    &.htops {
      padding: 0;
    }
    &.fullw {
      .email-verification-hint {
        width: 100%;
      }
    }
    .email-verification-hint {
      padding: 0.5rem 0.75rem;
      border-radius: $radiusLg;
      &--valid {
        border: 1px solid #22ac8a5c;
      }
      &--invalid {
        border: 1px solid #ff8c005c;
      }
    }
  }
}
</style>